export const PROCESS = {
  PREP: {
    code: 'PREP',
    name: '备料工序',
    step: 1,
  },
  DRILL_NON_LAYER: {
    code: 'DRILL_NON_LAYER',
    name: '进泥孔加工(逐孔)',
    step: 2,
  },
  HEAT_TREATMENT: {
    code: 'HEAT_TREATMENT',
    name: '委外热处理',
    step: 3,
  },
  DRILL_LAYER: {
    code: 'DRILL_LAYER',
    name: '进泥孔精加工',
    step: 4,
  },
  // 清洗烘干：后端 process_definition 已存在（code=CLEANING_DRYING），前端补齐登记即可
  CLEANING_DRYING: {
    code: 'CLEANING_DRYING',
    name: '清洗烘干',
    step: 5,
  },
  GUIDE_SLOT_EDM: {
    code: 'GUIDE_SLOT_EDM',
    name: '导料槽 - 放电加工',
    step: 6,
  },
  GUIDE_SLOT_WIRE: {
    code: 'GUIDE_SLOT_WIRE',
    name: '导料槽 - 中丝加工',
    step: 7,
  },
  GUIDE_SLOT_CUTTER: {
    code: 'GUIDE_SLOT_CUTTER',
    name: '导料槽 - 切槽机加工',
    step: 8,
  },
  SHAPE_WIRE_CUT: {
    code: 'SHAPE_WIRE_CUT',
    name: '外形加工 - 线割',
    step: 9,
  },
  SHAPE_ENGRAVING: {
    code: 'SHAPE_ENGRAVING',
    name: '外形加工 - 精雕机',
    step: 10,
  },
  // 调模组去毛刺：前端登记；后端 process_definition 暂无此行，需补 Flyway 迁移方可建记录
  DEBURRING: {
    code: 'DEBURRING',
    name: '调模组去毛刺',
    step: 11,
  },
  SELF_CHECK: {
    code: 'SELF_CHECK',
    name: '裸模自检',
    step: 12,
  },
  // 模芯加工（含斜边放电加工等子类型）；原"模芯台阶加工"改名
  CORE_STEP: {
    code: 'CORE_STEP',
    name: '模芯加工',
    step: 13,
  },
  IN_STORAGE: {
    code: 'IN_STORAGE',
    name: '入库',
    step: 14,
  },
} as const

export type ProcessCode = keyof typeof PROCESS

export const PROCESS_LIST = Object.values(PROCESS).sort((a, b) => a.step - b.step)

export const PROCESS_STATUS = {
  PENDING: { value: 'pending', label: '待开始', color: '#909399' },
  IN_PROGRESS: { value: 'in_progress', label: '进行中', color: '#2383e2' },
  COMPLETED: { value: 'completed', label: '已完成', color: '#27ae60' },
  REJECTED: { value: 'rejected', label: '已驳回', color: '#f56c6c' },
} as const
